/**
 * QA 2026-10-01 F-04 — the stored form of a US phone number.
 *
 * Accepts 10 digits, or 11 digits starting with 1, in any common format:
 * "(205) 555-0123", "205.555.0123", "205-555-0123", "+1 205 555 0123",
 * "2055550123". Returns "(205) 555-0123", the same format the staff profile
 * already stores (`PHONE_NUMBER_FORMAT` in `schemas/user-profile.ts`).
 *
 * Returns null for too few or too many digits ("12", "555-0123"), letters
 * ("205-555-CALL"), extensions ("205-555-0123 x12") and blank input. Only
 * digits, spaces, dots, dashes, parentheses and one leading "+" are allowed
 * between the digits.
 */
export function normalizeUsPhone(input) {
    if (typeof input !== 'string')
        return null;
    const trimmed = input.trim();
    if (trimmed === '')
        return null;
    if (!/^\+?[\d\s().-]+$/.test(trimmed))
        return null;
    let digits = trimmed.replace(/\D/g, '');
    if (digits.length === 11 && digits.startsWith('1'))
        digits = digits.slice(1);
    if (digits.length !== 10)
        return null;
    // A "+" is only meaningful before the country code.
    if (trimmed.startsWith('+') && !/^\+\s*1/.test(trimmed))
        return null;
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}
/** Field message for an invalid phone, shared by the server and the forms. */
export const US_PHONE_INVALID_MESSAGE = 'Use a 10-digit US phone number, like (205) 555-0123.';
//# sourceMappingURL=phone.js.map